import { Columns } from '@/types/table';

const ORDER_LIST_COLUMNS: Columns[] = [
  {
    name: 'Address',
    selector: 'propertyAddress',
    type: 'component',
    width: '300px',
    isSortableByHeader: true,
    sticky: 'left'
  },
  {
    name: 'Order Date',
    selector: 'orderDate',
    type: 'date',
    width: '145px'
  },
  {
    name: 'Appointment Date',
    selector: 'appointments.dateStartLocal',
    type: 'text',
    width: '200px'
  },
  {
    name: 'Assets',
    selector: 'asset',
    type: 'component',
    width: '160px',
    isSortableByHeader: false
  },
  {
    name: 'Order Status',
    selector: 'orderStatus',
    type: 'component',
    width: '330px',
    isSortableByHeader: true
  },
  {
    name: 'Services Ordered',
    selector: 'servicesOrdered',
    type: 'component',
    width: '320px',
    isSortableByHeader: false
  },
  {
    name: 'Order ID',
    selector: 'orderNumber',
    type: 'component',
    width: '135px',
    isSortableByHeader: true
  },
  {
    name: 'Order Notes',
    selector: 'orderNotes',
    type: 'component',
    width: '300px',
    isSortableByHeader: false
  },
  {
    name: 'Amount',
    selector: 'orderAmount',
    type: 'component',
    width: '165px',
    cssClass: 'order-amount',
    isSortableByHeader: false
  },
  {
    name: 'Ordered By',
    selector: 'orderedBy',
    type: 'text',
    width: '200px'
  },
  // {
  //   name: 'Order method',
  //   selector: 'orderMethod',
  //   type: 'text',
  //   width: '200px'
  // },

  // {
  //   name: ' Reorder/Reschedule for UTCs',
  //   selector: 'rescheduleForUTCs',
  //   type: 'text',
  //   width: '230px'
  // },
  {
    name: 'Order Completed Date',
    selector: 'orderCompletedDate',
    type: 'date',
    width: '220px'
  },
  {
    name: 'Payment Method',
    selector: 'paymentMethod',
    type: 'component',
    width: '250px',
    isSortableByHeader: false
  },
  {
    name: 'Property ID',
    selector: 'clientPropertyId',
    type: 'text',
    width: '200px',
    isSortableByHeader: false
  },
  {
    name: 'Unit ID',
    selector: 'clientUnitId',
    type: 'text',
    width: '200px',
    isSortableByHeader: false
  },
  {
    name: 'Unable to Complete',
    selector: 'unableToComplete',
    type: 'text',
    width: '210px'
  },

  {
    name: 'Unable to Complete Reason',
    selector: 'unableToCompleteReason',
    type: 'text',
    width: '250px',
    isSortableByHeader: true
  },
  {
    name: 'Unable to Complete Notes',
    selector: 'unableToCompleteNotes',
    type: 'component',
    width: '250px',
    isSortableByHeader: false
  },
  {
    name: 'Access Type',
    selector: 'accessType',
    type: 'text',
    width: '200px',
    isSortableByHeader: false
  },

  {
    name: 'On-Site Contact Name',
    selector: 'onsiteContactName',
    type: 'text',
    width: '220px',
    isSortableByHeader: false
  },

  {
    name: 'Schedule Later Date',
    selector: 'firstAvailableDate',
    type: 'date',
    width: '240px'
  },

  // {
  //   name: 'View/Download invoice',
  //   selector: 'downloadInvoice',
  //   type: 'text',
  //   width: '200px'
  // },

  {
    name: 'Entity',
    selector: 'entity',
    type: 'text',
    width: '200px'
  },
  {
    name: 'Gate Code',
    selector: 'gateCode',
    type: 'text',
    width: '200px',
    isSortableByHeader: false
  },
  {
    name: 'Lockbox Location',
    selector: 'lockboxLocation',
    type: 'text',
    width: '200px',
    isSortableByHeader: false
  },

  {
    name: '',
    selector: 'moreOption',
    type: 'component',
    width: '10px',
    isSortableByHeader: false,
    sticky: 'right'
  }
];

export default ORDER_LIST_COLUMNS;
